var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-4 text-center"},[_c('img',{attrs:{"src":("data:image/png;base64," + _vm.qrcode),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }